import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import { SpTable, SpTableCell, SpTableRow } from '../../../../components/bundles/SpTable';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { isMobile } from 'react-device-detect';
import { findReportsByStationId } from '../../../../models/actions/Reports';
import { UserSessionContext } from '../../../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationClosedReports = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [reportsList, setReportsList] = useState([]);
  const [displayRentsList, setDisplayRentsList] = useState([]);
  const { stationId } = useParams();
  const { setDialogUserPNOpen, setDialogEndRent, setSelectedReportDetailClosed } = props;
  const { authData, setAuthData } = useContext(UserSessionContext);

  const fetchData = async () => {
    if (stationId) {
      try {
        const response = await findReportsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          const filteredData = response.filter((elem) => elem.status == 'close' && elem.rent?.bikes?.length > 0);
          setReportsList(filteredData);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const headCells = [
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Codice bicicletta',
      isAction: false
    },
    {
      id: 'data inizio',
      numeric: false,
      disablePadding: false,
      label: 'Data inizio',
      isAction: false
    },
    {
      id: 'data fine',
      numeric: false,
      disablePadding: false,
      label: 'Data fine',
      isAction: false
    },
    {
      id: 'loan',
      numeric: false,
      disablePadding: false,
      label: 'Sanzione (€)',
      isAction: false
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email utente',
      isAction: false
    },
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Stazione prelievo',
      isAction: false
    },
    {
      id: 'azioni',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];
  //rendering the profile editing form
  const ReportRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <SpTableRow
        role="checkbox"
        id={row?.id}
        tabIndex={index}
      >
        <SpTableCell>
          <SpText variant="tableText">{row.rent?.bikes[0]?.code}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.creation_date ? moment(row.creation_date).format('DD/MM/yyyy') : null}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.closing_date ? moment(row.closing_date).format('DD/MM/yyyy') : null}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText
            variant="tableText"
            type="number"
          >
            {row.amount_to_pay ? row.amount_to_pay : '0'}
          </SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.user?.email}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent?.bikes[0]?.station?.client_id}</SpText>
        </SpTableCell>
        <TableCell
          align={'right'}
          style={{
            padding: 0,
            verticalAlign: 'center',
            borderBottom: 0
          }}
        >
          <SpButton
            text="Vedi"
            variant={'tableAction'}
            onClick={() => setSelectedReportDetailClosed({ rent: row.rent, report: row, status: true })}
          />
        </TableCell>
      </SpTableRow>
    );
  };

  return (
    <div style={{ padding: 8 }}>
      <SpTable
        pagination={true}
        headCells={headCells}
        rows={reportsList}
        rowKey="id"
        padding={false}
        notCheckable={false}
        tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
      >
        <ReportRow />
      </SpTable>
    </div>
  );
};

export default withSnackbar(StationClosedReports);
